import { format } from "date-fns";
import { CalendarIcon, DeleteIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
type DatePickerInputProps = {
  value?: Date;
  onValueChange: (value?: Date) => void;
  label: string | undefined;
  canPickYear?: boolean;
  className?: string;
  disabled?: boolean;
};
const DatePickerInput = ({
  value,
  onValueChange,
  label,
  canPickYear,
  className,
  disabled
}: DatePickerInputProps) => {
  return <Popover data-sentry-element="Popover" data-sentry-component="DatePickerInput" data-sentry-source-file="date-picker.tsx">
      <PopoverTrigger asChild data-sentry-element="PopoverTrigger" data-sentry-source-file="date-picker.tsx">
        <Button disabled={disabled} variant={"outline"} className={cn("h-12 w-full rounded-3xl px-4 text-left font-normal", !value && "text-muted-foreground", className || [])} data-sentry-element="Button" data-sentry-source-file="date-picker.tsx">
          {value ? format(value, "PPP") : <span>{label}</span>}
          {/* Add an X icon */}
          {value && !disabled ? <DeleteIcon onClick={() => onValueChange(undefined)} className="ml-auto h-4 w-4 opacity-50" /> : <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-sentry-element="PopoverContent" data-sentry-source-file="date-picker.tsx">
        <Calendar mode="single" selected={value} onSelect={onValueChange} initialFocus captionLayout={canPickYear ? "dropdown" : "dropdown-months"} fromYear={1900} toYear={new Date().getFullYear() + 1} data-sentry-element="Calendar" data-sentry-source-file="date-picker.tsx" />
      </PopoverContent>
    </Popover>;
};
export default DatePickerInput;